export class EnquiryUrlCheckModule {

    constructor() {
        this.init();
    }

    init() {
        let dataEnquiry = $('*[data-enquiry-url-check]');
        if ($("#component-enquiryform").length > 0) {
            dataEnquiry.attr("href", "#accustomerenquiryform");    
        } else {
            dataEnquiry.attr("href", "/enquire");
        }

    }

}


